export const environment = {
  production: true,
  siteKey: '6Ldkq_whAAAAAEV8qh0ShAHO5k2QuR3nIYw3p90Q',
  api: 'https://nhc-api-web-dev-lrie36jqyq-ue.a.run.app/api',
  apiHis: 'https://newonline-apihis-dot-so-desarrollo-test-352717.ue.r.appspot.com/api',
  apiMira: 'https://mira-api-dot-so-desarrollo-test-352717.ue.r.appspot.com/api',
  apiHigiene: 'https://nhc-api-higiene-dev-lrie36jqyq-ue.a.run.app/api',
  habilitarPaseLaboral: 1,
  chatHubUrl: 'https://testnewonline.natclar.com.pe:8077/chat',
  rolInvitado: '3203cc85-69cd-4835-a24e-257304141dd8',
  rolTrabajador: '87ecd12c-4873-4086-a5c5-f1418107c65e',
  bucketSoporte: 'so-txadmin-nh-test',
  bucketEmpresas: 'so-empresas-test',
  bucketDocumentos: 'so-documentos-test',
};
